import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Permission } from '../models/user/permission';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    constructor(private readonly httpClient: HttpClient) {}

    async get(): Promise<Permission[]> {
        return firstValueFrom(this.httpClient.get<Permission[]>('permission'));
    }
}
